module.exports = __webpack_public_path__ + "static/media/ios-git-merge.3686d876.svg";